<mat-card>
  <mat-card-header class="bg-info text-white">
    <mat-card-title>{{ message }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form (ngSubmit)="onSubmit()">
      <div fxLayoutAlign="center center">
        <dropzone #dropzone [config]="dropzoneConfig" class="dropzone-container" (success)="onUploadSuccess($event)"
          (addedFile)="onAddedFile($event)" (removedFile)="onRemovedFile($event)" fxLayout="row"
          fxLayoutAlign="start strech" fxFlex="auto"></dropzone>
      </div>
    </form>
    <br />
    <div *ngFor="let file of filesAdded" fxLayoutAlign="center center">
      <mat-form-field>
        <input matInput [placeholder]="'Nuevo nombre del archivo ' + (file.index + 1)" [(ngModel)]="file.newName">
      </mat-form-field>
    </div>
    <br />
    <mat-card-actions fxLayoutAlign="center center">
      <button *ngIf="this.filesAdded.length > 0" type="button" [disabled]="clicked" clicked="true;" mat-raised-button color="primary" (click)="onSubmit()">
        Subir
      </button>
      <button type="button" mat-raised-button color="warn" (click)="closeDialog()">
        Cancelar
      </button>
    </mat-card-actions>
  </mat-card-content>
</mat-card>
